import ShareSheetModal, { ShareSheetModalProps } from './ShareSheetModal';

export type { ShareSheetModalProps };
export default ShareSheetModal;
